import Table, { TableProps } from '@mui/material/Table';

export default function ResponsiveTable(props: TableProps) {
    return (
            <Table {...props} stickyHeader />
    );
}